module.exports = __webpack_public_path__ + "img/box9-02.4a6ecf98.png";